module.exports = {
  calcInteractions: () => {
    let interactionsEl = document.querySelector('.interactions')

    let sixteenNineAspect = 16 / 9
    let viewportHeight = window.innerHeight
    let viewportWidth = window.innerWidth
    let widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect
    let heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect

    if (widthIfConstarainedByHeight <= viewportWidth) {
      interactionsEl.style.width = widthIfConstarainedByHeight + 'px'
      interactionsEl.style.height = viewportHeight + 'px'
    } else {
      interactionsEl.style.width = viewportWidth + 'px'
      interactionsEl.style.height = heightIfConstarainedByWidth + 'px'
    }
  },
  calcModals: () => {
    let modalDialogEls = document.querySelectorAll('.modal-dialog')

    if (modalDialogEls.length > 0) {
      let sixteenNineAspect = 16 / 9
      let viewportHeight = window.innerHeight
      let viewportWidth = window.innerWidth
      let widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect
      let heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect

      modalDialogEls.forEach((el) => {
        if (widthIfConstarainedByHeight <= viewportWidth) {
          el.style.width = widthIfConstarainedByHeight + 'px'
          el.style.height = viewportHeight + 'px'
        } else {
          el.style.width = viewportWidth + 'px'
          el.style.height = heightIfConstarainedByWidth + 'px'
        }
      })
    }
  },
  calcImageSliders: () => {
    let imageSliderEls = document.querySelectorAll('.swiper-slide > *')

    if (imageSliderEls.length > 0) {
      let sixteenNineAspect = 16 / 9
      let viewportHeight = document.documentElement.clientHeight
      // let viewportHeight = window.innerHeight;
      let viewportWidth = document.documentElement.clientWidth
      // let viewportWidth = window.innerWidth;
      let widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect
      let heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect

      imageSliderEls.forEach((el) => {
        if (widthIfConstarainedByHeight <= viewportWidth) {
          el.style.width = widthIfConstarainedByHeight + 'px'
          el.style.height = viewportHeight + 'px'
          el.parentElement.style.width = widthIfConstarainedByHeight + 'px'
        } else {
          el.style.width = viewportWidth + 'px'
          el.style.height = heightIfConstarainedByWidth + 'px'
          el.parentElement.style.width = viewportWidth + 'px'
        }
      })
    }
  },
  showModalContent: () => {
    let content = document.querySelector('.modal-body > *')

    if (!!content) {
      content.classList.add('opacity-100')

      if (content.tagName === 'VIDEO') {
        content.play()
      }
    }
  },
  hideModalContent: () => {
    let content = document.querySelector('.modal-body > *')

    if (!!content) {
      content.classList.remove('opacity-100')
    }
  },
}
